import { fromPromise } from 'xstate';

import { apolloClient } from '@/lib/apollo';
import { PublishRulePackageMutation, ViewRulePackagesQuery } from '@/lib/gql/__generated__/canonical-documents';
import type {
  PublishRulePackageInput,
  PublishRulePackageMutationMutation,
  ViewRulePackagesQueryQuery,
} from '@/lib/gql/__generated__/graphql';

export const viewRulePackagesActor = fromPromise<ViewRulePackagesQueryQuery, void>(async () => {
  const result = await apolloClient.query({
    query: ViewRulePackagesQuery,
  });

  if (!result.data) {
    throw new Error('Rule Packages could not be loaded.');
  }

  return result.data;
});

export const publishRulePackageActor = fromPromise<PublishRulePackageMutationMutation, PublishRulePackageInput>(
  async ({ input }) => {
    const result = await apolloClient.mutate({
      mutation: PublishRulePackageMutation,
      variables: {
        input: {
          rulePackageId: input.rulePackageId,
          taxYear: input.taxYear,
          version: input.version,
          fileRef: input.fileRef,
        },
      },
    });

    if (!result.data) {
      throw new Error('The Rule Package could not be published.');
    }

    const response = result.data.publishRulePackage;
    if (!response?.success) {
      throw new Error(response?.error?.message ?? 'The Rule Package could not be published.');
    }

    return result.data;
  },
);
